module.exports = __webpack_public_path__ + "img/Male.ed84bdab.png";